import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const RO: DeepPartial<Payments> = {
    useReceiverEndpoint: true,
    redoReplyEngine: 'paymentService',
    checkDomesticMatchString:
        /^[\w öüäôáďéěíňóřšťúůýžąàâãåæăćčĉęèëêĝĥìïîĵłľńòőõðøśșŝțŭùűûñÿçżźÖÜÄÔÁĎÉĚÍŇÓŘŠŤÚŮÝŽĄÀÂÃÅÆĂĆČĈĘÈËÊĜĤÌÏÎĴŁĽŃÒŐÕÐØŚȘŜȚŬÙŰÛÑŸÇŻŹß()&.,-/+<>?;!"={}:_%*#§|\\$^[\]'\u20AC@]+$/.toString(),
    feeFlags: false,
    additionalCopyableAttributes: ['ro-billPaymentInfo', 'ro-treasuryInfo'],
    handleLocalErrors: {
        errorCode: 'RO-BE_LOCAL_ERROR',
        translationPath: 'parameters.RO-BE_ERR_TXT',
    },
    disableTransferDateForFX: true,
    useCollectiveSigning: true,
};
